import type { PropsWithChildren } from 'react';

import { useCanGoBack, useRouter } from '@tanstack/react-router';
import { VariantProps } from 'class-variance-authority';

import { Button } from '@/lib/shadcn/components/ui/button/button';
import { buttonVariants } from '@/lib/shadcn/components/ui/button/button-variants';
import { cn } from '@/lib/shadcn/lib/utils.ts';

type Props = {
  className?: string;
  onClick?: () => void;
  fallback?: () => void;
  disabled?: boolean;
};
export function BackToPageButton({
  className,
  children,
  onClick,
  fallback,
  ...props
}: VariantProps<typeof buttonVariants> & PropsWithChildren<Props>) {
  const router = useRouter();
  const canGoBack = useCanGoBack();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (fallback) {
      fallback();
    } else if (canGoBack) {
      router.history.back();
    } else {
      router.navigate({ to: '/', replace: true });
    }
  };

  return (
    <Button
      onClick={handleClick}
      className={cn('inline-flex gap-unit-4', className)}
      {...props}
    >
      {children}
    </Button>
  );
}
